// Matches the panel's `duration-300` close animation.
export const SIDEBAR_CLOSE_MS = 100;

type SidebarNavigation = {
  isMobile: boolean;
  closeSidebar: () => void;
  navigate: () => void;
};

/**
 * Leaves the sidebar for another screen. On mobile the open sidebar covers the
 * whole screen, so it has to close first — navigating straight away leaves the
 * panel over the new page and hides the route transition behind it.
 */
export function navigateFromSidebar({
  isMobile,
  closeSidebar,
  navigate,
}: SidebarNavigation) {
  if (!isMobile) {
    navigate();
    return;
  }

  closeSidebar();
  setTimeout(navigate, SIDEBAR_CLOSE_MS);
}
